import React, { FC } from 'react';

import { Box, Text } from '@lucid/components-react';
import ReactHtmlParser from 'react-html-parser';
import { Drupal_ParagraphFlexiSection } from 'generated/drupal-graphql';
import { getProcessedValue } from '@lucid/utils';
import { LucidTheme } from '@lucid/theme';

import FlourishedHeading from 'components/flourished-heading/flourished-heading';

interface QuoteProps {
  entity: Drupal_ParagraphFlexiSection;
}

const Quote: FC<QuoteProps> = ({ entity }) => {
  return (
    <Box
      css={{ label: 'flexiStyledSectionQuote' }}
      gridColumn="1 / -1"
      mb={{ default: 4, tablet: 11 }}
      mx={{ default: -3, tablet: 0 }}
      px={{ default: 0, tablet: 6 }}
    >
      <FlourishedHeading
        css={(theme: LucidTheme) => ({
          maxWidth: '580px',
          marginBottom: theme.space[4]
        })}
        variant="headline2XL"
      >
        {entity.fieldFlexiHeader}
      </FlourishedHeading>
      <Box overflow="visible">
        <Box maxWidth={{ default: '100%', tablet: '580px' }}>
          <Text
            as="div"
            css={{
              '& > p': {
                marginTop: 0
              }
            }}
            variant="paragraphM300"
          >
            {ReactHtmlParser(getProcessedValue(entity.fieldFlexiBody))}
          </Text>
        </Box>
        {entity.fieldFlexiImage && (
          <Box
            css={{ textAlign: 'center' }}
            mb={{ default: 4, tablet: 6 }}
            mt={8}
            mx={{ default: -11, tablet: 'auto' }}
          >
            <img
              alt={entity.fieldFlexiHeader || ''}
              loading="lazy"
              src={entity.fieldFlexiImage || ''}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Quote;
